<template>
  <div>
    <button v-if="!loading" type="button" @click="openModal" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
      <i class="fa fa-eye"></i>
    </button>
    <span v-else class="spinner-border spinner-border-sm"></span>

    <div :id="'notification_modal_' + row.id" class="modal fade rtl" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title float-left p-0 m-0">جزئیات اعلان</h4>
            <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body mb-4">
            <table v-if="detail && detail.message" class="table table-hover">
              <thead>
                <tr><th class="table-info" colspan="2">پیام</th></tr>
              </thead>
              <tbody>
                <tr><td>متن پیام</td><td v-html="detail.message"></td></tr>
              </tbody>
            </table>

            <table v-if="parsedTokens && Object.keys(parsedTokens).length > 0" class="table table-hover">
              <thead>
                <tr><th class="table-info" colspan="2">توکن‌ها</th></tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in parsedTokens" :key="key">
                  <td style="width: 155px;">{{ key }}</td>
                  <td>{{ value }}</td>
                </tr>
              </tbody>
            </table>

            <table v-if="detail && detail.response !== null && detail.response !== undefined" class="table table-hover">
              <thead>
                <tr><th class="table-info" colspan="2">پاسخ</th></tr>
              </thead>
              <tbody>
                <tr><td>متن پاسخ</td><td>{{ detail.response }}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import { notificationService } from '@/common/api.service'

export default Vue.extend({
  props: {
    row: { required: true },
    index: { required: true },
    datatable: { required: true },
  },
  data() {
    return {
      loading: false,
      detail: null,
    }
  },
  computed: {
    parsedTokens() {
      if (!this.detail || !this.detail.tokens) return null
      if (typeof this.detail.tokens === 'object') return this.detail.tokens
      try {
        return JSON.parse(this.detail.tokens)
      } catch {
        return null
      }
    },
  },
  methods: {
    openModal() {
      if (this.detail) {
        $('#notification_modal_' + this.row.id).modal('show')
        return
      }
      this.loading = true
      notificationService.show(this.row.id)
        .then(({ data }) => {
          this.detail = data.data
          $('#notification_modal_' + this.row.id).modal('show')
        })
        .catch(() => {
          this.detail = null
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
})
</script>
